export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8079.40bb10a4.jpg";